import { render } from "./Documentos.vue?vue&type=template&id=6f38fe97&scoped=true"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"

import "./Documentos.vue?vue&type=style&index=0&id=6f38fe97&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f38fe97"]])

export default __exports__